import React, { useState, useEffect } from 'react'
import Menu from './scenes/Menu'
import Nav from './utils/Nav';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Nzakara from './scenes/Nzakara';
import Badung from './scenes/Badung';
import Compas from './scenes/Compas';
import Sardaigne from './scenes/Sardaigne';
import Diphonique from './scenes/Diphonique';
import Madagascar from './scenes/Madagascar';

export default function Player() {

  let audio = []

  return (
    <>
      <div className='background' />
      <BrowserRouter>
        <div>
          <Routes>
            <Route path={process.env.PUBLIC_URL + '/menu/'} element={<Menu audio={audio} />} />
            <Route path={process.env.PUBLIC_URL + '/nzakara/'} element={<Nzakara audio={audio} />} />
            <Route path={process.env.PUBLIC_URL + '/badung/'} element={<Badung audio={audio} />} />
            <Route path={process.env.PUBLIC_URL + '/compas/'} element={<Compas audio={audio} />} />
            <Route path={process.env.PUBLIC_URL + '/sardaigne/'} element={<Sardaigne audio={audio} />} />
            <Route path={process.env.PUBLIC_URL + '/diphonique/'} element={<Diphonique audio={audio} />} />
            <Route path={process.env.PUBLIC_URL + '/madagascar/'} element={<Madagascar audio={audio} />} />
            <Route path={process.env.PUBLIC_URL + '/madagascar/:page'} element={<Madagascar audio={audio} />} />
            <Route path="*" element={<Navigate to={process.env.PUBLIC_URL + "/menu/"} replace />} />
          </Routes>
        </div >
      </BrowserRouter>
    </>
  )
}
